import type { CommonProps } from "../../component.types.js";
import { ariaKeys } from "./const.js";
import type { OcAriaAttributes, SupportedAriaKey } from "./types.js";

type ArrayUnionToUnion<Union extends readonly unknown[]> = Union extends unknown
  ? Union[number]
  : never;

type DefaultAriaAttributes<ApplyTo extends Record<string, SupportedAriaKey[]>> = {
  default: Omit<OcAriaAttributes, `aria-${ArrayUnionToUnion<ApplyTo[keyof ApplyTo]>}`>;
};

type AriaAttributes<ApplyTo extends Record<string, SupportedAriaKey[]>> = {
  [K in keyof ApplyTo]: Pick<OcAriaAttributes, `aria-${ApplyTo[K][number]}`>;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function useAriaAttributes<ApplyTo extends Record<string, SupportedAriaKey[]>>(
  ariaProps: Required<CommonProps>["aria"],
  applyTo: ApplyTo = {} as unknown as ApplyTo,
): AriaAttributes<ApplyTo> & DefaultAriaAttributes<ApplyTo> {
  /*                                                          */
  const result: any = {
    default: {},
  };

  const applyToEntries = Object.entries(applyTo);

  ariaKeys.forEach((key) => {
    const ariaKey = `aria-${key}` as keyof OcAriaAttributes;
    const ariaValue = ariaProps[key];

    let isUnusedAriaKey = true;
    applyToEntries.forEach(([targetKey, targetValues]) => {
      result[targetKey] ??= {};
      if (targetValues.includes(key)) {
        result[targetKey][ariaKey] = ariaValue;
        isUnusedAriaKey = false;
      }
    });

    if (isUnusedAriaKey) {
      result.default[ariaKey] = ariaValue;
    }
  });

  return result;
}
